import { Injectable } from '@angular/core';
import {BehaviorSubject} from "rxjs";
import {StorageService} from "../storage.service";

@Injectable({
  providedIn: 'root'
})
export class SiteDataService {
  private moduleSource = new BehaviorSubject('');
  currentModuleSource = this.moduleSource.asObservable();

  private themeSubject = new BehaviorSubject('');
  currentTheme = this.themeSubject.asObservable();

  private subSystemSource = new BehaviorSubject('');
  currentSubSystemSource = this.subSystemSource.asObservable();

  private locateSource = new BehaviorSubject('');
  currentLocateSource = this.locateSource.asObservable();

  constructor(
      private storageService: StorageService
  ) {
    const currentSubSystem = this.storageService.getLocalItem('currentSubSystem');
    if (currentSubSystem && currentSubSystem.id) {
      this.changeSubSystem(currentSubSystem);
    }
    const defaultTheme = this.storageService.getLocalItem('defaultTheme');
    if (defaultTheme) {
      this.changeTheme(currentSubSystem);
    } else {
      this.changeTheme('default');
    }
  }

  public changeModule(navi: any) {
    this.moduleSource.next(navi);
  }

  public changeSubSystem(navi: any) {
    this.subSystemSource.next(navi);
  }

  public changeLocateItem(navi: any) {
    this.locateSource.next(navi);
  }

  public changeTheme(theme: any) {
    this.themeSubject.next(theme);
  }

}
